<section class="payout-method-info__container">
  <p class="payout-method-info__paragraph">
    Jammcard uses Stripe to get you paid quickly and keep your personal payment information secure. Click
    <strong>Continue to Payout Set Up</strong> to set up your Stripe account to get you paid with Jammcard.
  </p>
</section>
